export function Controls({
  onReset,
  onShare,
  onInfo,
  showInfo = false,
  className = "",
}: {
  onReset: () => void;
  onShare: () => void;
  onInfo: () => void;
  showInfo?: boolean;
  className?: string;
}) {
  return (
    <div className={`p-4 flex flex-col gap-3 border-b border-secondary/10 lg:border-b-0 ${className}`}>
      <div className="flex gap-3">
        <button
          onClick={onReset}
          className="btn flex-1 py-2 px-4 rounded font-semibold transition-all duration-150"
        >
          Reset
        </button>
        <button
          onClick={onShare}
          className="btn orange flex-1 py-2 px-4 rounded font-semibold transition-all duration-150"
        >
          Share
        </button>
        <button
          onClick={onInfo}
          className={`btn lg:hidden flex-1 py-2 px-4 rounded font-semibold transition-all duration-150 ${showInfo ? "orange" : ""}`}
        >
          Info
        </button>


      </div>
      <button
        onClick={() => alert("adding to cart")}
        className="btn orange border-secondary w-full py-2 px-4 rounded font-semibold transition-all duration-150"
      >
        Add to Cart
      </button>
    </div>
  );
}
